import { Controller } from 'react-hook-form';
import { IconLoader, Select, SelectSize } from '@ui/src';
import InfoRow from './info-row';
import StepPartBlock from './step-part-block';
import { NewApplicationStatus } from '../../../hoc/common/types';
import { MonthlyVolumesTypes } from './types';

import commonStyles from './styles.module.css';

const MonthlyVolumes = ({
  zIndex,
  baseCurrency,
  control,
  clearErrors,
  monthlyTurnover,
  errors,
  status,
  isEditable,
  numberOfIncomingTransactions,
  numberOfOutgoingTransactions,
  valueOfIncomingTransactions,
  valueOfOutgoingTransactions,
  maxValueOfIncomingPayment,
  maxValueOfOutgoingPayment,
  infoDictionariesIsLoading,
}: MonthlyVolumesTypes) => {
  let content;

  if (infoDictionariesIsLoading) {
    content = (
      <div className={commonStyles.dictionaryLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        <InfoRow
          title={`Monthly Turnover (${baseCurrency?.name})`}
          id="monthlyTurnoverRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyTurnoverRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyTurnoverRangeId"
                placeholder="Select range"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyTurnoverRangeId']);
                }}
                list={monthlyTurnover}
                size={SelectSize.SMALL}
                error={errors?.monthlyTurnoverRangeId?.message}
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                borderless
                fullWidth
              />
            )}
          />
        </InfoRow>

        <InfoRow
          title="N. of incoming transactions"
          id="monthlyNumberIncomingTransactionsRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyNumberIncomingTransactionsRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyNumberIncomingTransactionsRangeId"
                placeholder="Select range"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyNumberIncomingTransactionsRangeId']);
                }}
                list={numberOfIncomingTransactions}
                size={SelectSize.SMALL}
                error={
                  errors?.monthlyNumberIncomingTransactionsRangeId?.message
                }
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
                borderless
              />
            )}
          />
        </InfoRow>
        <InfoRow
          title="N. of outgoing transactions"
          id="monthlyNumberOutgoingTransactionsRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyNumberOutgoingTransactionsRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyNumberOutgoingTransactionsRangeId"
                placeholder="Select range"
                list={numberOfOutgoingTransactions}
                value={value}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyNumberOutgoingTransactionsRangeId']);
                }}
                error={
                  errors?.monthlyNumberOutgoingTransactionsRangeId?.message
                }
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
                borderless
              />
            )}
          />
        </InfoRow>
        <InfoRow
          title={`Value of incoming transactions (${baseCurrency?.name})`}
          id="monthlyValueIncomingTransactionsRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyValueIncomingTransactionsRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyValueIncomingTransactionsRangeId"
                placeholder="Select range"
                list={valueOfIncomingTransactions}
                value={value}
                error={errors?.monthlyValueIncomingTransactionsRangeId?.message}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyValueIncomingTransactionsRangeId']);
                }}
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
                borderless
              />
            )}
          />
        </InfoRow>
        <InfoRow
          title={`Value of outgoing transactions (${baseCurrency?.name})`}
          id="monthlyValueOutgoingTransactionsRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyValueOutgoingTransactionsRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyValueOutgoingTransactionsRangeId"
                placeholder="Select range"
                list={valueOfOutgoingTransactions}
                value={value}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyValueOutgoingTransactionsRangeId']);
                }}
                error={errors?.monthlyValueOutgoingTransactionsRangeId?.message}
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
                borderless
              />
            )}
          />
        </InfoRow>
        <InfoRow
          title={`Max. value of incoming payment (${baseCurrency?.name})`}
          id="monthlyMaxValueIncomingPaymentRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyMaxValueIncomingPaymentRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyMaxValueIncomingPaymentRangeId"
                placeholder="Select range"
                list={maxValueOfIncomingPayment}
                value={value}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyMaxValueIncomingPaymentRangeId']);
                }}
                error={errors?.monthlyMaxValueIncomingPaymentRangeId?.message}
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
                borderless
              />
            )}
          />
        </InfoRow>
        <InfoRow
          title={`Max. value of outgoing payment (${baseCurrency?.name})`}
          id="monthlyMaxValueOutgoingPaymentRangeId"
          lessPadding
        >
          <Controller
            control={control}
            name="monthlyMaxValueOutgoingPaymentRangeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name="monthlyMaxValueOutgoingPaymentRangeId"
                placeholder="Select range"
                list={maxValueOfOutgoingPayment}
                value={value}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['monthlyMaxValueOutgoingPaymentRangeId']);
                }}
                error={errors?.monthlyMaxValueOutgoingPaymentRangeId?.message}
                selectWrapperClassName={
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.selectDisabled
                    : ''
                }
                tabIndex={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
                borderless
              />
            )}
          />
        </InfoRow>
      </>
    );
  }

  return (
    <StepPartBlock title="Monthly Volumes" zIndex={zIndex}>
      {content}
    </StepPartBlock>
  );
};

export default MonthlyVolumes;
